export default () => ({
  banner: {
    padding: 5,
    borderRadius: 6,
    background: "rgba(155,155,155,0.3)",
    height: 250,
  },
});
